import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { AppBarExt, DRAWER_WIDTH, ToolbarExt } from './Components';
import Logo from 'components/Logo';
import DrawerContent from './DrawerContent';
import NavContent from './NavContent';
import { Box, Drawer, IconButton } from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';

import { colors } from 'styles';
import Banner from 'components/Banner';
import { useAuth } from 'context/AuthContext';

const drawerStyles = {
  width: DRAWER_WIDTH,
  flexShrink: 0,
  backgroundImage: 'none',
  '& .MuiDrawer-paper': {
    backgroundColor: colors.back21,
    backgroundImage: 'none',
    width: DRAWER_WIDTH,
    boxSizing: 'border-box',
  },
};

const DashboardLayout = () => {
  const { user } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => setDrawerOpen((st) => !st);

  function renderContent() {
    return (
      <>
        <ToolbarExt>
          <Logo withText={true} width='100%' />
        </ToolbarExt>
        <DrawerContent />
      </>
    );
  }

  return (
    <>
      <Box sx={{ display: 'flex', height: '100vh' }}>
        <AppBarExt position='fixed' elevation={0}>
          <ToolbarExt sx={{ justifyContent: 'space-between' }}>
            <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
              <IconButton
                color='default'
                onClick={toggleDrawer}
                sx={{
                  border: (theme) => `1px solid ${colors.whiteFF}`,
                  marginRight: '15px',
                }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <NavContent />
          </ToolbarExt>
        </AppBarExt>

        <Drawer
          open={drawerOpen}
          onClose={toggleDrawer}
          sx={{
            display: { xs: 'block', lg: 'none' },
            ...drawerStyles,
          }}
        >
          {renderContent()}
        </Drawer>
        <Drawer
          sx={{
            display: { xs: 'none', lg: 'block' },
            ...drawerStyles,
          }}
          variant='permanent'
          anchor='left'
        >
          {renderContent()}
        </Drawer>
        <Box
          component='main'
          sx={{
            flexGrow: 1,
            bgcolor: colors.back38,
            px: 3,
            overflowX: 'hidden',
            overflowY: 'auto',
            height: '100vh',
          }}
        >
          <ToolbarExt />
          {user.role === 'agent' && <Banner />}
          <Box py={3}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DashboardLayout;
